import { render, staticRenderFns } from "./StringFacetFilter.vue?vue&type=template&id=dd6fcaaa&"
import script from "./StringFacetFilter.vue?vue&type=script&lang=js&"
export * from "./StringFacetFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports